/**
 * @file
 * Patria front video highlight controls and juicer wall.
 */

(function ($, Drupal) {

  'use strict';

  Drupal.behaviors.patriaHighlightVideoControls = {
    attach: () => {
      var iframe = document.querySelector('.video-highlight iframe');

      if (iframe) {
        var player = new Vimeo.Player(iframe);

        $('.video-highlight .video-controls__resume').on('click', function () {
          player.play();
          $('.video-highlight .video-controls__pause').show();
          $(this).hide();
          $('.video-highlight .field--name-field-video-highlight-title ').hide();
        });

        $('.video-highlight .video-controls__pause').on('click', function () {
          player.pause();
          $('.video-highlight .video-controls__resume').show();
          $(this).hide();
          $('.video-highlight .field--name-field-video-highlight-title ').show();
        });
      }

      /* Change juicer filter twitter text to X, add timeout so that juicer is loaded */
      setTimeout(() => {
        const juicerX = document.querySelector('.j-display-filters .j-x-twitter');
        if (juicerX) {
          juicerX.innerHTML = 'X';
        }
      }, 500);
    }
  };

})(jQuery, Drupal);
